import { render, staticRenderFns } from "./QsRankingDistribution.vue?vue&type=template&id=61406fc0&scoped=true&"
import script from "./QsRankingDistribution.vue?vue&type=script&lang=ts&"
export * from "./QsRankingDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61406fc0",
  null
  
)

export default component.exports